import PropTypes from 'prop-types';
import Presenter from 'utils/PropTypesPresenter';

export const getStatesOptions = states =>
  states.map(({ id, attributes: { name, active, code } }) => ({ label: name, value: code, active, id }));

export default new Presenter(
  {
    id: PropTypes.string,
    name: PropTypes.string,
    code: PropTypes.string,
    active: PropTypes.bool,
  },
  {},
);



// WEBPACK FOOTER //
// ./src/presenters/StatePresenter.js